var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page-wrapper" },
    [
      _c("Heading", {
        staticClass: "mb-5 text-center",
        attrs: { title: _vm.$t("new_account_title"), routeName: "vignette" },
      }),
      _c(
        "div",
        { staticClass: "container container-xs" },
        [
          _vm.status != 1
            ? [
                _c("div", { staticClass: "register-wrapper" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "newAccountEmail" } }, [
                      _vm._v(_vm._s(_vm.$t("label_email"))),
                    ]),
                    _c("span", { staticClass: "invalid-feedback" }, [
                      _vm._v(" " + _vm._s(_vm.errorMsgs.email) + " "),
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.email,
                          expression: "email",
                        },
                      ],
                      staticClass: "form-control",
                      class: { "has-error": _vm.errorMsgs.email },
                      attrs: { dusk: "newAccountEmail", type: "email" },
                      domProps: { value: _vm.email },
                      on: {
                        blur: _vm.validateEmail,
                        focus: function ($event) {
                          return _vm.clearErrors("email")
                        },
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.email = $event.target.value
                        },
                      },
                    }),
                  ]),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "newAccountPhone" } }, [
                      _vm._v(_vm._s(_vm.$t("label_phone"))),
                    ]),
                    _c("span", { staticClass: "invalid-feedback" }, [
                      _vm._v(" " + _vm._s(_vm.errorMsgs.phone) + " "),
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.phone,
                          expression: "phone",
                        },
                      ],
                      staticClass: "form-control",
                      class: { "has-error": _vm.errorMsgs.phone },
                      attrs: { dusk: "newAccountPhone", type: "tel" },
                      domProps: { value: _vm.phone },
                      on: {
                        blur: _vm.validatePhone,
                        focus: function ($event) {
                          return _vm.clearErrors("phone")
                        },
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.phone = $event.target.value
                        },
                      },
                    }),
                  ]),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "newAccountPassword" } }, [
                      _vm._v(_vm._s(_vm.$t("label_password"))),
                    ]),
                    _c("span", { staticClass: "invalid-feedback" }, [
                      _vm._v(" " + _vm._s(_vm.errorMsgs.password) + " "),
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.password,
                          expression: "password",
                        },
                      ],
                      staticClass: "form-control",
                      class: { "has-error": _vm.errorMsgs.password },
                      attrs: { dusk: "newAccountPassword", type: "password" },
                      domProps: { value: _vm.password },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.password = $event.target.value
                        },
                      },
                    }),
                  ]),
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "label",
                      { attrs: { for: "newAccountPasswordConfirmation" } },
                      [_vm._v(_vm._s(_vm.$t("label_confirm_password")))]
                    ),
                    _c("span", { staticClass: "invalid-feedback" }, [
                      _vm._v(" " + _vm._s(_vm.errorMsgs.passwordVerify) + " "),
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.passwordVerify,
                          expression: "passwordVerify",
                        },
                      ],
                      staticClass: "form-control",
                      class: { "has-error": _vm.errorMsgs.passwordVerify },
                      attrs: {
                        dusk: "newAccountPasswordConfirmation",
                        type: "password",
                      },
                      domProps: { value: _vm.passwordVerify },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.passwordVerify = $event.target.value
                        },
                      },
                    }),
                  ]),
                  _c("div", { staticClass: "form-group" }, [
                    _c("span", { staticClass: "invalid-feedback" }, [
                      _vm._v(" " + _vm._s(_vm.errorMsgs.acceptanceTerms) + " "),
                    ]),
                    _c("div", { staticClass: "d-flex" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.acceptanceTerms,
                            expression: "acceptanceTerms",
                          },
                        ],
                        attrs: {
                          dusk: "acceptanceTerms",
                          type: "checkbox",
                          name: "acceptanceTerms",
                          id: "acceptanceTerms",
                        },
                        domProps: {
                          checked: Array.isArray(_vm.acceptanceTerms)
                            ? _vm._i(_vm.acceptanceTerms, null) > -1
                            : _vm.acceptanceTerms,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.acceptanceTerms,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.acceptanceTerms = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.acceptanceTerms = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.acceptanceTerms = $$c
                            }
                          },
                        },
                      }),
                      _c("p", { attrs: { for: "acceptanceTerms" } }, [
                        _vm._v(_vm._s(_vm.$t("new_account_ive_read")) + " "),
                        _c(
                          "a",
                          {
                            staticClass: "link",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                $event.preventDefault()
                                return _vm.openModal("termsModal")
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("new_account_tc")) + " ")]
                        ),
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("new_account_site")) +
                            " " +
                            _vm._s(_vm.$t("and")) +
                            " "
                        ),
                        _c(
                          "a",
                          {
                            staticClass: "link",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                $event.preventDefault()
                                return _vm.openModal("confidentialityModal")
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("new_account_pc")) + " ")]
                        ),
                      ]),
                    ]),
                  ]),
                  _c("div", {}, [
                    _c(
                      "div",
                      { staticClass: "text-center" },
                      [
                        _c(
                          "van-button",
                          {
                            staticClass: "main-btn",
                            attrs: {
                              loading: _vm.loading,
                              dusk: "create-new-account-btn",
                              type: "primary",
                              "loading-type": "spinner",
                              "loading-text": "Se creeaza",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.create()
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("btn_create_account")) + " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "login-wrapper" }, [
                    _c(
                      "p",
                      { staticClass: "text-center" },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("already_have_account")) + " "
                        ),
                        _c(
                          "router-link",
                          { attrs: { to: { name: "login" } } },
                          [_vm._v(" " + _vm._s(_vm.$t("btn_login")) + " ")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
                _vm.status
                  ? _c(
                      "div",
                      {
                        staticClass: "text-center alert mt-3",
                        class: {
                          "alert-danger": _vm.status == -1,
                          "alert-success": _vm.status == 1,
                        },
                      },
                      [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.message) },
                        }),
                      ]
                    )
                  : _vm._e(),
              ]
            : _vm._e(),
          _vm.message.length
            ? [
                _c("div", { staticClass: "text-center alert alert-success" }, [
                  _vm._v(" " + _vm._s(_vm.message) + " "),
                ]),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "modal", attrs: { id: "termsModal", tabindex: "-1" } },
        [
          _c("div", { staticClass: "modal-dialog modal-lg" }, [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c("h5", { staticClass: "modal-title" }, [
                  _vm._v(_vm._s(_vm.$t("terms"))),
                ]),
                _vm._m(0),
              ]),
              _c(
                "div",
                { staticClass: "modal-body" },
                [_c("terms", { attrs: { "in-modal": true } })],
                1
              ),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.f_agreeTC()
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("btn_i_understand")) + " ")]
                ),
              ]),
            ]),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "modal",
          attrs: { id: "confidentialityModal", tabindex: "-1" },
        },
        [
          _c("div", { staticClass: "modal-dialog modal-lg" }, [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c("h5", { staticClass: "modal-title" }, [
                  _vm._v(_vm._s(_vm.$t("new_account_pc"))),
                ]),
                _vm._m(1),
              ]),
              _c(
                "div",
                { staticClass: "modal-body" },
                [_c("confidentiality", { attrs: { "in-modal": true } })],
                1
              ),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.f_agreePC()
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("btn_i_understand")) + " ")]
                ),
              ]),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close",
        },
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close",
        },
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }